import React from 'react';
import { Drawer, IconButton } from '@economic/taco';

export function HelpDrawerActions(): React.JSX.Element {
    return (
        <Drawer.Actions>
            <IconButton icon="undock" appearance="discrete" className="text-xs" />
        </Drawer.Actions>
    );
}
